export const CommonText = {
  WELCOME: "Welcome to ",
  APP_NAME_TEXT: "AAM Hub",
  HOME_TEXT: "Please select an option from the menu to continue.",
};